"use client"

import { Children, type ReactNode } from "react"

import { useTranslations } from "next-intl"

import { CarouselDots, Reel, Row } from "@/components/ui"
import { useReelPagination } from "@/lib/hooks/use-reel-pagination"

export const HeroReel = ({ children }: { children: ReactNode }) => {
  const t = useTranslations("common")
  const slides = Children.toArray(children)
  const { ref, index, stops, goTo } = useReelPagination(slides.length)
  return (
    <div role="region" aria-roledescription="carousel" aria-label={t("heroSlides")}>
      <Reel ref={ref} gap="200" snap>
        {slides.map((slide, slideIndex) => (
          <div key={slideIndex} role="group" aria-roledescription="slide" aria-label={t("heroSlidePosition", { index: slideIndex + 1, count: slides.length })} className="w-full">
            {slide}
          </div>
        ))}
      </Reel>
      <Row justify="center" className="pt-300">
        <CarouselDots tone="plain" activeColor="bg-brand" count={stops} index={index} onChange={goTo} />
      </Row>
    </div>
  )
}
